var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenu03Filled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1C8.89543 1 8 1.89543 8 3H6C4.89543 3 4 3.89543 4 5V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V5C20 3.89543 19.1046 3 18 3H16C16 1.89543 15.1046 1 14 1H10ZM14.5 3C14.5 2.72386 14.2761 2.5 14 2.5H10C9.72386 2.5 9.5 2.72386 9.5 3V4.5C9.5 4.77614 9.72386 5 10 5H14C14.2761 5 14.5 4.77614 14.5 4.5V3ZM15.25 10.75C15.6642 10.75 16 10.4142 16 10C16 9.58579 15.6642 9.25 15.25 9.25H8.75C8.33579 9.25 8 9.58579 8 10C8 10.4142 8.33579 10.75 8.75 10.75H15.25ZM14 14C14 14.4142 13.6642 14.75 13.25 14.75H8.75C8.33579 14.75 8 14.4142 8 14C8 13.5858 8.33579 13.25 8.75 13.25H13.25C13.6642 13.25 14 13.5858 14 14Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu03Filled);
export default __webpack_public_path__ + "static/media/icon_menu03_filled.cff9f18d7461bcf3929694d45d1f8b29.svg";
export { ForwardRef as ReactComponent };